<template>
  <div class="assistant-container">
    <div class="assistant-box">
      <div class="header">
        <h1><span>熵聘智能招聘助手</span></h1>
        <p class="desc">让 AI 成为你的招聘助手，不止解放双手，更懂 “精准识人”</p>
      </div>
      <el-row :gutter="20" class="card-row">
        <div class="card-box">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <lpcardBox></lpcardBox>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <bosscardBox></bosscardBox>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <zlcardBox></zlcardBox>
          </el-col>
        </div>
      </el-row>
      <div class="talent-pool" @click="handleTalent">
        <div class="pool-box">
          <h3 class="talent-title"><i class="el-icon-tickets" style="margin-right: 3px;"></i>我的人才库</h3>
          <p class="talent-desc">查看和管理已保存的人才简历库</p>
        </div>
      </div>
      <div class="info">
        <div class="status">{{ usernick }}</div>
        <div class="date">到期时间：{{ usertime }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import bosscardBox from "../components/BossCardBox.vue";
import lpcardBox from "../components/LPCardBox.vue";
import zlcardBox from "../components/ZLCardBox.vue";
import { DeepSeek, jobNameGetAIKnow } from '../request/api'
export default {
  created() {

    if (!sessionStorage.getItem("LoginInfo")) {
      this.$router.push("/error");
    } else {
      this.userID = JSON.parse(sessionStorage.getItem("LoginInfo")).ID
      this.userID = JSON.parse(sessionStorage.getItem("LoginInfo")).ID
      this.com_id = JSON.parse(sessionStorage.getItem("LoginInfo")).com_id
      this.Token = JSON.parse(sessionStorage.getItem("LoginInfo")).Token
      this.usertime = JSON.parse(sessionStorage.getItem("LoginInfo")).usertime
      this.username = JSON.parse(sessionStorage.getItem("LoginInfo")).username
      const hour = new Date().getHours();
      if (hour < 12) {
        this.usernick = "上午好，" + JSON.parse(sessionStorage.getItem("LoginInfo")).usernick
      } else if (hour < 18) {
        this.usernick = "下午好，" + JSON.parse(sessionStorage.getItem("LoginInfo")).usernick
      } else {
        this.usernick = "晚上好，" + JSON.parse(sessionStorage.getItem("LoginInfo")).usernick
      }
      this.airoom = JSON.parse(sessionStorage.getItem("LoginInfo")).airoom
      this.usertime = this.usertime.split(' ')[0].replace(/-/g, '/');
    }
    this.aitest();
  },
  data() {
    return {
      com_id: '',
      Token: '',
      usertime: '',
      usernick: '',
      airoom: '',
      userID: '',
      username: ''
    }
  },
  components: { bosscardBox, lpcardBox, zlcardBox },
  methods: {
    async aitest() {
      var { data: res } = await jobNameGetAIKnow({ username: this.username, positionName: '测试' });
      console.log(res);
    },
    handleTalent() {
      window.open("/#/home/search?sign=" + this.Token + "&username=" + this.username + "&timestamp=" + Date.now())
    },
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.assistant-container {
  height: 100vh;
  color: #fff;
  background-color: #111927;
  /* 模拟深色背景，可根据实际调整 */
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .assistant-box {

    .header {
      text-align: center;
      margin-bottom: 40px;
      user-select: none;

      h1 {
        font-weight: 700;
        line-height: 1;
        margin-bottom: 10px;
        font-size: 40px;

        span {
          color: transparent;
          background-clip: text;
          --tw-gradient-to: #ec4899;
          --tw-gradient-from: #3b82f6;
          --tw-gradient-stops: #3b82f6, #ec4899;
          background-image: linear-gradient(to right, #3b82f6, #ec4899);
        }
      }

      .desc {
        font-size: 16px;
        color: #ccc;
        margin-top: 10px;
      }
    }

    .features {
      display: flex;
      justify-content: space-around;
      margin-bottom: 30px;
      user-select: none;

      .feature-item {
        width: 40%;
        text-align: center;
        box-shadow: 0px 0px 1px 1px #252d3a;
        border-radius: 10px;
        background-color: #1e2834;
        padding: 15px;
        line-height: 1.5;

        .feature-title {
          text-align: left;
          font-size: 18px;
          margin-bottom: 10px;
        }

        .feature-desc {
          text-align: left;
          font-size: 14px;
          color: #ccc;
          margin-bottom: 20px;
        }

        .feature-img {
          width: 100px;
          height: 150px;
          margin: 0 auto 20px;

          .avatar-female {
            width: 100%;
            height: 100%;
            background: url('') no-repeat center/contain;
          }

          .avatar-male {
            width: 100%;
            height: 100%;
            background: url('') no-repeat center/contain;
          }
        }

        .btn {
          padding: 10px 20px;
          background-image: linear-gradient(to right, #4a79ef, #9c207c);
          color: #fff;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.5s ease;
          /* 添加过渡效果 */

        }

        .btn:hover {
          background-image: linear-gradient(to right, #6c5ce7, #8e44ad);
          /* 应用新的渐变 */
        }
      }

    }

    .card-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .talent-pool {
      margin-top: 40px;
      padding: 12px 10px;
      background-color: #1e2834;
      text-align: left;
      border-radius: 10px;
      user-select: none;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      transition: all 0.475s;
      box-shadow: 0px 0px 6px 1px #252d3a;

      .pool-box {
        position: relative;
        z-index: 1;
      }

      .talent-title {
        font-size: 16px;
        letter-spacing: 1px;
        margin-bottom: 5px;
        transition: color 0.475s;
        /* 添加颜色过渡效果 */
      }

      .talent-desc {
        font-size: 14px;
        letter-spacing: 1px;
        color: #ccc;
        transition: color 0.475s;
        /* 添加颜色过渡效果 */
      }
    }

    .talent-pool:hover::before {
      transform: scaleX(1);
    }

    .talent-pool::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      transform: scaleX(0);
      transform-origin: 0 50%;
      width: 100%;
      height: 100%;
      border-radius: inherit;
      background: linear-gradient(82.3deg,
          rgba(150, 93, 233, 1) 10.8%,
          rgba(99, 88, 238, 1) 94.3%);
      transition: all 0.475s;
    }

    .info {
      user-select: none;
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: #2e3642;
      padding: 10px 10px;
      border-radius: 10px;

      .status {
        font-size: 14px;
        letter-spacing: 1px;
        margin-bottom: 5px;
      }

      .status::before {
        content: '';
        width: 8px;
        height: 8px;
        display: inline-block;
        /* 转为行内块元素，便于设置宽高 */
        border-radius: 50%;
        background-color: #47cb74;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        vertical-align: center;
        /* 垂直居中对齐 */
        margin-right: 8px;
      }

      .date {
        color: #ccc;
        font-size: 12px;
      }
    }
  }
}
</style>